import { Trans, useTranslation } from 'react-i18next'

import { FormatPrice, Link, returnStatuses, Text } from '@reveni-io/reveni-ui'

import { allowedTransactionTypes } from '@/constants'

const SuccessMessage = ({
  remainingAmount,
  issueExchangeAtStatus,
  transactionType,
  customerEmail,
  currency,
  storeReplyToEmail,
}) => {
  const { t } = useTranslation()

  const isInstantExchangeOrIssueExchangeInProgress = () => {
    return (
      transactionType === allowedTransactionTypes.instantExchange || issueExchangeAtStatus === returnStatuses.inProgress
    )
  }

  return (
    <>
      <Text type="bodyMRegular">
        <Trans
          i18nKey="successCompletedMessage"
          values={{ amount: remainingAmount || 0 }}
          defaults="El pago de <strong><price>{{amount}}</price></strong> por tu solicitud de cambio de productos ha sido completado con éxito."
          components={{ strong: <strong />, price: <FormatPrice currency={currency || 'EUR'} /> }}
        />
      </Text>

      <Text type="bodyMRegular">
        {isInstantExchangeOrIssueExchangeInProgress() && (
          <>
            {t('En breve recibirás las instrucciones para devover tus productos en ')} <strong>{customerEmail}</strong>
          </>
        )}
        {[returnStatuses.shipped, returnStatuses.received, returnStatuses.accepted].includes(issueExchangeAtStatus) &&
          t('En breve se procesará el nuevo pedido con los productos que has solicitado.')}
      </Text>

      <Text type="bodyMRegular">
        {t('Si tienes alguna duda, contacta con nosotros escribiendo a ')}
        <Link href={`mailto:${storeReplyToEmail}`}>{storeReplyToEmail}</Link>
      </Text>
    </>
  )
}

export default SuccessMessage
